class Observer {
  constructor() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    });
    this.elements = [];
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      const element = entry.target;
      if (entry.isIntersecting) {
        if (element.dataset.type === 'video') {
          element.play();
        } else if (element.dataset.type === 'swiper') {
          element.swiper.autoplay.resume();
        }
      } else {
        if (element.dataset.type === 'video') {
          element.pause();
        } else if (element.dataset.type === 'swiper') {
          element.swiper.autoplay.pause();
        }
      }
    });
  }

  observe(element, type) {
    element.dataset.type = type;
    this.elements.push(element);
    this.observer.observe(element);
  }

  disconnect() {
    this.elements.forEach((element) => this.observer.unobserve(element));
    this.elements = [];
  }

  init() {
    const videoos = document.querySelectorAll('.videoo');
    if (videoos.length === 0) return;

    videoos.forEach((video) => {
      this.observe(video, 'video');
    });
  }
}

const observer = new Observer();
export default observer;
